import { Component } from '@angular/core';
import { QuestionnaireComponent } from '../../questionnaire/questionnaire.component';
import { ApiService } from '../../_services/api.service';
import { ConfigService } from '../../_services/config.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'true-trl',  
  templateUrl: './trl.component.html',
  styleUrls: ['./trl.component.scss', '../section-overview/section-overview.component.scss'],
  standalone: false
})

export class TrlComponent extends QuestionnaireComponent {
  // 1.	Begin at TRL 1 and answer each question in order.
  // 2.	Stop if you answer "No." The TRL is the level of the last "Yes."
  // 3.	If you say "Yes" to all questions, the TRL is 9.
  trlLevelReached = false;
  trlLevel = 0;
  constructor(api: ApiService, public readonly config: ConfigService, dialog: MatDialog) {
    super(api, config, dialog);
  }

  getTemplateId(): string {    
    return 'TRL';
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadTrl();
  }

  loadTrl(): void {
    this.assessmentData$.subscribe((assessmentData) => {
      if (!assessmentData) {        
        return;
      }
      this.checkTRL();   
    });
  }

  checkTRL(): void {
    const answers = this.sections.map(section => section.answer?.trim().toLowerCase() || '');
    let firstNoIndex = -1;
  
    for (let i = 0; i < answers.length; i++) {
      if (answers[i] === 'no') {
        firstNoIndex = i;
        break;
      }
    }
  
    if (firstNoIndex !== -1) {
      console.log("First item ID with answer 'No':", firstNoIndex);
      this.trlLevelReached = true;
      this.trlLevel = firstNoIndex;
      this.selectSection(this.sections[firstNoIndex]);
    } else if (answers.every(answer => answer === 'yes')) {
      console.log("All answers are 'Yes'. TRL is 9.");
      this.trlLevelReached = true;
      this.trlLevel = 9;
      super.nextSection();
    } else {
      console.log("No 'No' answers found, but not all answered yet.");
    }
  }

  yes(): void {    
    this.selectedSection.answer = "Yes";
    this.saveAllToBackend();

    const allAnswered = this.sections.every(section => section.answer?.trim().toLowerCase() === 'yes' || section.answer?.trim().toLowerCase() === 'no');

    if (allAnswered) {
      this.checkTRL();
    } else {
      // Move to next section until the end or a "No" answer is reached
      const currentIndex = this.sections.findIndex(section => section.id === this.selectedSection.id);
      // Check if the current index is valid and less than the last index    
      if (currentIndex !== -1 && currentIndex < this.sections.length - 1) {
          // Move to the next section
          this.selectSection(this.sections[currentIndex + 1]);
      } else {
        this.trlLevel = 9;
        this.trlLevelReached = true;
        super.nextSection();
      }
    }    
  }

  no(): void {
    this.selectedSection.answer = "No";        
    this.saveAllToBackend();    
    this.checkTRL();
  }

  saveAllToBackend(): void {
    if (!this.selectedSection) return;
  
    const currentId = this.selectedSection.id;
    const currentAnswer = this.selectedSection.answer?.trim().toLowerCase();
  
    let sectionsToSave = this.sections.filter(section => {
      if (currentAnswer === 'yes' && section.id <= currentId) {
        section.answer = 'yes';
        return true;
      } else if (currentAnswer === 'no' && section.id >= currentId) {
        section.answer = 'no';
        return true;
      }
      return false;
    });
  
    let saveCount = 0;
  
    sectionsToSave.forEach(section => {
      this.api.updateAssessmentQuestionnaireAnswer(section.answer, this.questionnaireAssesmentId, section.id).subscribe(
        (ret: any) => {
          section.answerId = ret.answer.id;  
          // Only update last save time and animation once (on last call)
          saveCount++;
          if (saveCount === sectionsToSave.length) {
            this.lastSaveTime = new Date().toLocaleTimeString();
            this.animate = true;
            console.log(`All ${sectionsToSave.length} sections saved`);
          }
        },
        (error) => console.error(`Failed to save section ${section.id}`, error)
      );
    });
  }
}
